module.exports = __webpack_public_path__ + "static/media/Jamie Paster Headshot.dfc49a08.jpeg";